<a (click)="openPdfFile()" class="a_without_href">
    <i-bs [name]="iconNames.FilePdf"></i-bs>
    <ng-content></ng-content>
</a>
<adobe-pdf-viewer></adobe-pdf-viewer>